import { gql } from '@apollo/client';

export const AUTH_SESSION_QUERY = gql`
  query PayAtPumpUsersAuthSessionQuery {
    payAtPumpUsersSession
  }
`;
